import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'edex-admin-info',
  templateUrl: './admin-info.component.html',
  styleUrls: ['./admin-info.component.scss']
})
export class AdminInfoComponent implements OnInit {

  public userId: string;
  info: any;
  constructor(    private route: ActivatedRoute,
    private router: Router,
    public location: Location) { }

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id');
    console.log(this.router.url);
    if(this.router.url.includes('/admin/sales-agent/merchant')){
      this.info= "Sales Agent Info";
    }else{
      this.info = "Admin Info";
    }
  }
}
